import queryString from 'query-string';
import { get } from './apiUtils';

const defaultUrl = '/ImpactAssessmentActions/';

export default {
  getImpactAssessmentActions: ({ id, query } = {}) =>
    get(`${defaultUrl}${id || ''}${query ? '?'.concat(queryString.stringify(query)) : ''}`),
};
